//This function holds some data for the mock exercises we have currently

export default function ExercisesData() {
  return [
    {
      exerciseName: "Jumping Jacks",
      reps: "30 sec",
      category: "Cardio",
      id: "Jumping Jacks",
      workout: "LegsCardio"
    },
    {
      exerciseName: "Mountain Climbers",
      reps: "30 sec",
      category: "Cardio",
      id: "Mountain Climbers",
      workout: "LegsCardio"
    },
    {
      exerciseName: "Plank Frog Jumps",
      reps: "30 sec",
      category: "Cardio",
      id: "Plank Frog Jumps",
      workout: "LegsCardio"
    },
    {
      exerciseName: "Commando",
      reps: "30 sec",
      category: "Cardio",
      id: "Commando",
      workout: "CoreAbs"
    },
    {
      exerciseName: "Burpees",
      reps: "30 sec",
      category: "Cardio",
      id: "Burpees",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Fly Jacks",
      reps: "30 sec",
      category: "Cardio",
      id: "Fly Jacks",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Lunges",
      reps: "30 sec",
      category: "Legs",
      id: "Lunges",
      workout: "LegsCardio"
    },
    {
      exerciseName: "High Knees",
      reps: "30 sec",
      category: "Legs",
      id: "High Knees",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Split Jumps",
      reps: "30 sec",
      category: "Legs",
      id: "Split Jumps",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Calf Raises",
      reps: "30 sec",
      category: "Legs",
      id: "Calf Raises",
      workout: "LegsCardio"
    },
    {
      exerciseName: "Step-Ups",
      reps: "30 sec",
      category: "Legs",
      id: "Step",
      workout: "LegsCardio"
    },
    {
      exerciseName: "Squats",
      reps: "30 sec",
      category: "Legs",
      id: "Squats",
      workout: "LegsCardio"
    },
    {
      exerciseName: "Donkey Kicks",
      reps: "30 sec",
      category: "Legs",
      id: "Donkey Kicks",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Push-Ups",
      reps: "30 sec",
      category: "Chest",
      id: "Push-Ups",
      workout: "ChestDay"
    },
    {
      exerciseName: "Chest Extensions",
      reps: "30 sec",
      category: "Chest",
      id: "Chest Extensions",
      workout: "ChestDay"
    },
    {
      exerciseName: "Chest Expanders",
      reps: "30 sec",
      category: "Chest",
      id: "Chest Expanders",
      workout: "ChestDay"
    },
    {
      exerciseName: "Wide Push Ups",
      reps: "30 sec",
      category: "Chest",
      id: "Wide Push Ups",
      workout: "ChestDay"
    },
    {
      exerciseName: "Superman Push Ups",
      reps: "30 sec",
      category: "Chest",
      id: "Superman Push Ups",
      workout: "ChestDay"
    },
    {
      exerciseName: "Star Push Ups",
      reps: "30 sec",
      category: "Chest",
      id: "Star Push Ups",
      workout: "ShouldersChallenge"
    },
    {
      exerciseName: "Chest Flies",
      reps: "30 sec",
      category: "Chest",
      id: "Chest Flies",
      workout: "ChestDay"
    },
    {
      exerciseName: "Crunches",
      reps: "30 sec",
      category: "Abs",
      id: "Crunches",
      workout: "CoreAbs"
    },
    {
      exerciseName: "Bicycles",
      reps: "30 sec",
      category: "Abs",
      id: "Bicycles",
      workout: "CoreAbs"
    },
    {
      exerciseName: "Plank",
      reps: "30 sec",
      category: "Abs",
      id: "Plank",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Six Inch Hold",
      reps: "30 sec",
      category: "Abs",
      id: "Six Inch Hold",
      workout: "CoreAbs"
    },
    {
      exerciseName: "Side Plank",
      reps: "30 sec",
      category: "Abs",
      id: "Side Plank",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Side Knee Tucks",
      reps: "30 sec",
      category: "Abs",
      id: "Side Knee Tucks",
      workout: "CoreAbs"
    },
    {
      exerciseName: "Butt Ups",
      reps: "30 sec",
      category: "Abs",
      id: "Butt Ups",
      workout: "CoreAbs"
    },
    {
      exerciseName: "Tricep Dips",
      reps: "30 sec",
      category: "Arms",
      id: "Tricep Dips",
      workout: "BicepsTriceps"
    },
    {
      exerciseName: "Bicep Curls",
      reps: "30 sec",
      category: "Arms",
      id: "Bicep Curls",
      workout: "BicepsTriceps"
    },
    {
      exerciseName: "Reverse Bicep Curls",
      reps: "30 sec",
      category: "Arms",
      id: "Reverse Bicep Curls",
      workout: "BicepsTriceps"
    },
    {
      exerciseName: "Close Grip Bicep Curls",
      reps: "30 sec",
      category: "Arms",
      id: "Close Grip Bicep Curls",
      workout: "BicepsTriceps"
    },
    {
      exerciseName: "Tricep Extensions",
      reps: "30 sec",
      category: "Arms",
      id: "Tricep Extensions",
      workout: "BicepsTriceps"
    },
    {
      exerciseName: "Overhead Tricep Extensions",
      reps: "30 sec",
      category: "Arms",
      id: "Overhead Tricep Extensions",
      workout: "BicepsTriceps"
    },
    {
      exerciseName: "Diamond Push Ups",
      reps: "30 sec",
      category: "Arms",
      id: "Diamond Push Ups",
      workout: "BicepsTriceps"
    },
    {
      exerciseName: "Lateral Raises",
      reps: "30 sec",
      category: "Shoulders",
      id: "Lateral Raises",
      workout: "ShouldersChallenge"
    },
    {
      exerciseName: "Front Raises",
      reps: "30 sec",
      category: "Shoulders",
      id: "Front Raises",
      workout: "ShouldersChallenge"
    },
    {
      exerciseName: "Reverse Flies",
      reps: "30 sec",
      category: "Shoulders",
      id: "Reverse Flies",
      workout: "ShouldersChallenge"
    },
    {
      exerciseName: "Pike Push Ups",
      reps: "30 sec",
      category: "Shoulders",
      id: "Pike Push Ups",
      workout: "ShouldersChallenge"
    },
    {
      exerciseName: "Arm Circles Lateral",
      reps: "30 sec",
      category: "Shoulders",
      id: "Arm Circles Lateral",
      workout: "ShouldersChallenge"
    },
    {
      exerciseName: "Overhead Presses",
      reps: "30 sec",
      category: "Shoulders",
      id: "Overhead Presses",
      workout: "ShouldersChallenge"
    },
    {
      exerciseName: "Supermans - back",
      reps: "30 sec",
      category: "Back",
      id: "Supermans - back",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Pull Ups",
      reps: "30 sec",
      category: "Back",
      id: "Pull Ups",
      workout: ""
    },
    {
      exerciseName: "Wide Grip Pull Ups",
      reps: "30 sec",
      category: "Back",
      id: "Wide Grip Pull Ups",
      workout: ""
    },
    {
      exerciseName: "Rows",
      reps: "30 sec",
      category: "Back",
      id: "Rows",
      workout: "ShouldersChallenge"
    },
    {
      exerciseName: "Wind Mill",
      reps: "30 sec",
      category: "Back",
      id: "Wind Mill",
      workout: "Calisthenics"
    },
    {
      exerciseName: "Renegade Rows",
      reps: "30 sec",
      category: "Back",
      id: "Renegade Rows",
      workout: "ShouldersChallenge"
    }
  ];
}
